import Button from "@material-ui/core/Button";
import Drawer from "@material-ui/core/Drawer";
import Grid from "@material-ui/core/Grid";
import Link from "@material-ui/core/Link";
import MenuList from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Paper from "@material-ui/core/Paper";
import Popover from "@material-ui/core/Popover";
import withStyles from "@material-ui/core/styles/withStyles";
import Tooltip from "@material-ui/core/Tooltip";
import { instance } from "Actions/AxiosInstance";
import DefaultProfileImage from "Assets/Images/profile_defaultImg.svg";
import deleteIcon from "Assets/newicons/action/delete-bin/outline/delete-bin-outline-16px.svg";
import editIcon from "Assets/newicons/action/edit/outline/edit-outline-16px.svg";
import calenderIcon from "Assets/newicons/user-interface/calendar/outline/calendar-outline-16px.svg";
import kebabIcon from "Assets/newicons/user-interface/kebab/glyph/kebab-glyph-16px.svg";
import taskIcon from "Assets/newicons/user-interface/task/outline/task-outline-16-px.svg";
import classNames from "classnames";
import DynamicForm from "Component/DynamicForm";
import { checkboxinputconverter } from "Component/DynamicForm/Fields/CheckBox";
import DrawerHeader from "Component/Headers/drawerHeader";
import IconLabel from "Component/Labels/IconLabel";
import ScheduleActivityDrawer from "Module/Subscription/Recruit/ScheduleActivityDrawer";
import moment from "moment";
import { withSnackbar } from "notistack";
import React from "react";
import { connect } from "react-redux";
import { getFormattedImageLink } from "Utils";

const styles = () => ({
  drawerPaper: {
    width: "30%",
  },
});

const GetNumberOfEmp = (count) => {
  if (count >= 3) {
    return count - 3;
  }
  return 0;
};

export class ScheduleActivity extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      moreOptions: false,
      moreOptions_anchorEl: null,
      drawerOpen: false,
      selecteddata: null,
      activitydata: null,
      isapicall: true,
      completeactivity: this.props.activityList.filter(
        (x) => x.activitystatusid == 3,
      ),
      pendingactivity: this.props.activityList.filter(
        (x) => x.activitystatusid == 1,
      ),
      // scheduledactivity: this.props.activityList.filter(x => x.activitystatusid == 3),
      iscandidateactivityedit: false,
      addedparticipant: null,
    };
    this.moreOptionsClick = this.moreOptionsClick.bind(this);
    this.onDelete = this.onDelete.bind(this);
    this.onEdit = this.onEdit.bind(this);
    this.apiCallfun = this.apiCallfun.bind(this);
  }

  onCloseDrawer = () => {
    this.setState({ drawerOpen: false });
    // this.props.closeActivity();
  };

  componentDidUpdate() {
    if (this.props.isapicall) {
      this.setState({
        completeactivity: this.props.activityList.filter(
          (x) => x.activitystatusid == 3,
        ),
        pendingactivity: this.props.activityList.filter(
          (x) => x.activitystatusid == 1,
        ),
        isapicall: true,
      });
      this.props.resetApiCall();
    }
  }

  // componentWillUpdate() {
  //   this.props.getCandidateActivity();
  // }

  apiCallfun() {
    this.setState(
      {
        isapicall: false,
      },
      () => this.props.getCandidateActivity(),
    );
  }

  handleChange = (index, value, key, id) => {
    const { pendingactivity, completeactivity } = this.state;
    const { activityList } = this.props;
    if (id == 1) {
      pendingactivity[index][key] = value;
      this.setState({ pendingactivity });
    }
    if (id == 3) {
      completeactivity[index][key] = value;
      this.setState({ completeactivity });
    }
    // activityList[index][key] = value;
    // this.setState({ activityList });
  };

  moreOptionsClick(event, data) {
    this.setState({
      moreOptions: !this.state.moreOptions,
      moreOptions_anchorEl: event.currentTarget,
      selecteddata: data,
    });
  }

  onSave() {
    const { pendingactivity } = this.state;
    const data = pendingactivity.filter((x) => x.checked);

    this.props.enqueueSnackbar(
      "Are you sure  you have completed these activities ?",
      {
        variant: "warning",
        action: [
          <Button
            key="key"
            color="inherit"
            size="small"
            onClick={() => {
              // const { selectedRow } = this.state;
              this.props.closeSnackbar();
              instance
                .post("recruit/updateactivitystatus", {
                  activitystatusid: 3,
                  activityids: data.map((x) => x.activityid),
                })
                .then((result) => {
                  this.onCloseDrawer();
                  this.props.getCandidateActivity();
                  // this.props.getData(this.props.carddata);
                  this.props.enqueueSnackbar("Saved successfully", {
                    variant: "success",
                  });
                })
                .catch((error) => {
                  this.props.enqueueSnackbar(
                    error.response
                      ? error.response.data.error.message
                      : error.message,
                    { variant: "error" },
                  );
                });
            }}
          >
            Yes
          </Button>,
          <Button
            key="key"
            color="inherit"
            size="small"
            onClick={() =>
              this.setState({ createmenu: false }, () =>
                this.props.closeSnackbar(),
              )
            }
          >
            No
          </Button>,
        ],
      },
    );
  }

  onEdit() {
    const { selecteddata } = this.state;
    instance
      .get(`recruit/getactivity/${selecteddata.activityid}`)
      .then((result) => {
        this.setState({
          iscandidateactivityedit: true,
          activitydata: result.data.result[0],
          addedparticipant:
            result.data.result[0] && result.data.result[0].participant,
          drawerOpen: true,
        });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  onDelete() {
    const { selecteddata } = this.state;
    console.log("selecteddata: ", selecteddata);
    const data = {
      activityid: selecteddata && selecteddata.activityid,
      candidateid: selecteddata && selecteddata.candidateid,
      // ishistory: true,
    };
    const URL = `recruit/deleteactivity`;

    this.props.enqueueSnackbar(
      "Are you sure  you want to delete this activity ?",
      {
        variant: "warning",
        action: [
          <Button
            key="key"
            color="inherit"
            size="small"
            onClick={() => {
              // const { selectedRow } = this.state;
              this.props.closeSnackbar();
              instance
                .post(URL, data)
                .then((result) => {
                  // this.setState({
                  //   isapicall: false,
                  // });
                  this.props.getCandidateActivity();
                  this.props.enqueueSnackbar("Deleted successfully", {
                    variant: "success",
                  });
                })
                .catch((error) => {
                  const CommonError = error.response
                    ? error.response.data.error.message
                    : error.message;
                  this.props.enqueueSnackbar(CommonError, { variant: "error" });
                });
            }}
          >
            Yes
          </Button>,
          <Button
            key="key"
            color="inherit"
            size="small"
            onClick={() =>
              this.setState({ createmenu: false }, () =>
                this.props.closeSnackbar(),
              )
            }
          >
            No
          </Button>,
        ],
      },
    );
  }

  renderActivity = (data, index, id) => (
    <Paper
      classNames="rounded-rectangle-paper"
      style={{ padding: 16, position: "relative", marginBottom: 16 }}
    >
      <div className="display-flex">
        <div className="">
          <DynamicForm
            fields={checkboxinputconverter({
              value: data.activitystatusid == 3 || data.checked,
              placeholder: "",
              label: "",
              disabled:
                (data.activitystatusid != 3 &&
                  this.props.selectedrow &&
                  this.props.selectedrow.isrecruiter) ||
                (this.props.selectedrow &&
                  this.props.selectedrow.ishiringowner) ||
                (this.props.selectedrow &&
                  this.props.selectedrow.ishiringmanager)
                  ? false
                  : true,
            })}
            onChange={(value) => {
              this.handleChange(index, value, "checked", id);
            }}
          />
        </div>
        <div className="margin-top-2">
          <span>
            <IconLabel
              label={data.title}
              img={taskIcon}
              className="margin-bottom-8"
            />
            <IconLabel
              label={`Due in ${
                moment(data.activitydue, "YYYY-MM-DD").diff(
                  new Date(),
                  "days",
                ) + 1
              } days`}
              img={calenderIcon}
              className="margin-bottom-8"
            />

            <Grid container>
              <div
                className="avtar-thumb-wrapper-small"
                style={{ height: 20, marginLeft: 0 }}
              >
                {data.participant && data.participant.length > 0 ? (
                  data.participant.map(
                    (emp, index) =>
                      index < 3 && (
                        <Tooltip
                          key="key"
                          title={emp.employeename || emp.fullname}
                          placement="bottom"
                        >
                          <div
                            className={
                              GetNumberOfEmp(data.participant.length) > 0
                                ? "avtar-thumb-blur"
                                : "avtar-thumb"
                            }
                            style={{
                              height: 20,
                              width: 20,
                              marginLeft: -4,
                            }}
                          >
                            <Link
                              to={`./profile/${emp.employeeid}`}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <div
                                className="avatar-wrapper-small"
                                style={{ height: 20 }}
                              >
                                {emp.imagepath == null ? (
                                  <img
                                    src={DefaultProfileImage}
                                    height="20"
                                    className="team-avatar"
                                  />
                                ) : (
                                  <img
                                    src={getFormattedImageLink(emp.imagepath)}
                                    height="20"
                                    className="team-avatar"
                                  />
                                )}
                              </div>
                            </Link>
                          </div>
                        </Tooltip>
                      ),
                  )
                ) : (
                  <div style={{ marginLeft: -8 }}>
                    <p
                      className="extra-small-dark-secondary"
                      style={{ paddingTop: 6 }}
                    >
                      No Employee Assigned
                    </p>
                  </div>
                )}
              </div>
              {data.participant && data.participant.length > 0 ? (
                GetNumberOfEmp(data.participant.length) > 0 ? (
                  <div
                    style={{
                      marginTop: 3,
                      height: 20,
                      width: 20,
                      marginLeft: 10,
                      fontSize: 14,
                    }}
                  >
                    +{GetNumberOfEmp(data.participant.length)}
                  </div>
                ) : (
                  ""
                )
              ) : (
                ""
              )}
            </Grid>
          </span>
        </div>
      </div>

      <div style={{ position: "absolute", right: 16, top: 16 }}>
        {this.props.selectedrow &&
          (this.props.selectedrow.isrecruiter ||
            this.props.selectedrow.ishiringowner ||
            this.props.selectedrow.ishiringmanager) && (
            <img
              src={kebabIcon}
              className="floatright"
              onClick={(event) => this.moreOptionsClick(event, data)}
            ></img>
          )}
      </div>
      <Popover
        open={this.state.moreOptions}
        anchorEl={this.state.moreOptions_anchorEl}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        onClick={() => this.setState({ moreOptions: false })}
        className="margin-top-8"
      >
        <Paper style={{ width: 200 }}>
          <div>
            <MenuList>
              <ListItem
                button
                className="padding-right-0 padding-top-4 padding-bottom-4 cursor-pointer"
                // disabled={
                //   this.props.selectedrow &&
                //   (this.props.selectedrow.isrecruiter ||
                //     this.props.selectedrow.ishiringowner ||
                //     this.props.selectedrow.ishiringmanager)
                //     ? true
                //     : false
                // }
                onClick={this.onEdit}
              >
                <ListItemIcon>
                  <img src={editIcon}></img>
                </ListItemIcon>
                <ListItemText style={{ padding: 0 }}>
                  <span className="small-dark-secondary">Edit</span>
                </ListItemText>
              </ListItem>

              <ListItem
                button
                className="padding-right-0 padding-top-4 padding-bottom-4 cursor-pointer"
                // disabled={!this.props.isparticipant}
                onClick={this.onDelete}
              >
                <ListItemIcon>
                  <img src={deleteIcon}></img>
                </ListItemIcon>
                <ListItemText style={{ padding: 0 }}>
                  <span className="small-dark-secondary">Delete</span>
                </ListItemText>
              </ListItem>
            </MenuList>
          </div>
        </Paper>
      </Popover>
    </Paper>
  );

  render() {
    const { classes } = this.props;
    return (
      <div>
        {/* <div className="position-rel">
          <Button
            className="btn btn-primary-md-blue "
            variant="contained"
            onClick={() => this.setState({ drawerOpen: true })}
            style={{ position: "absolute", right: -16, top: -66 }}
          >
            Schedule activity
          </Button>
        </div>
        {this.renderActivity()} */}
        {this.state.completeactivity && this.state.completeactivity.length > 0 && (
          <div className="dashed-divider1 position-rel text-center">
            <span
              style={{
                background: "#fff",
                position: "relative",
                top: -14,
                padding: "0px 24px",
              }}
              className="extra-small-dark-secondary"
            >
              Completed activities
            </span>
          </div>
        )}
        {this.state.completeactivity &&
          this.state.completeactivity.length > 0 &&
          this.state.completeactivity.map((x, index) =>
            this.renderActivity(x, index, 3),
          )}
        {this.state.pendingactivity && this.state.pendingactivity.length > 0 && (
          <div
            className="dashed-divider1 position-rel text-center"
            style={{ marginTop: 40 }}
          >
            <span
              style={{
                background: "#fff",
                position: "relative",
                top: -14,
                padding: "0px 24px",
              }}
              className="extra-small-dark-secondary"
            >
              Pending activities
            </span>
          </div>
        )}
        {this.state.pendingactivity &&
          this.state.pendingactivity.length > 0 &&
          this.state.pendingactivity.map((x, index) =>
            this.renderActivity(x, index, 1),
          )}

        {this.state.pendingactivity &&
          this.state.pendingactivity.length == 0 &&
          this.state.completeactivity &&
          this.state.completeactivity.length == 0 && (
            <p className="nomral-dark">No activities</p>
          )}

        {this.props.activityList &&
          this.props.activityList.filter((x) => x.checked).length > 0 && (
            <Button
              color="primary"
              variant="contained"
              className="btn btn-primary-md-blue margin-top-16"
              onClick={this.onSave.bind(this)}
            >
              Save
            </Button>
          )}
        <Drawer
          anchor="right"
          open={this.state.drawerOpen}
          onClose={() =>
            this.setState({
              drawerOpen: false,
            })
          }
          classes={{
            paper: classNames(classes.drawerPaper, "planner-drawer padding16"),
          }}
        >
          <DrawerHeader
            header="Schedule activity"
            isbackarrow={false}
            closeDrawer={() =>
              this.setState({
                drawerOpen: false,
              })
            }
          />
          <ScheduleActivityDrawer
            {...this.state}
            {...this.props}
            onCloseDrawer={this.onCloseDrawer}
            // getCandidateActivity={this.props.getCandidateActivity}
            apiCallfun={this.apiCallfun}
          />
        </Drawer>
      </div>
    );
  }
}

const mapStateToProps = () => ({});

export default connect(mapStateToProps)(
  withStyles(styles, { withTheme: true })(withSnackbar(ScheduleActivity)),
);
